var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricefloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000099663670840749242890000017009413590598986146_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 876.2 317.6",
    style: {
      enableBackground: "new 0 0 876.2 317.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.48;fill:#1DB2D7;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#006D7F;}\n\t.st3{fill:#043E4B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.2,
    y: 124.5,
    className: "st0",
    width: 686.4,
    height: 192.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.4,
    y: -135.7,
    transform: "matrix(0.2565 -0.9666 0.9666 0.2565 111.8369 586.8914)",
    className: "st1",
    width: 10,
    height: 712.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "95.1,317.6 92.4,307.9 784.7,124.1 787.3,133.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.6,225.6h-12v-6h12V225.6z M398.6,225.6h-12v-6h12V225.6z M374.6,225.6h-12v-6h12V225.6z M350.6,225.6h-12 v-6h12V225.6z M326.6,225.6h-12v-6h12V225.6z M302.6,225.6h-12v-6h12V225.6z M278.6,225.6h-12v-6h12V225.6z M254.6,225.6h-12v-6h12 V225.6z M230.6,225.6h-12v-6h12V225.6z M206.6,225.6h-12v-6h12V225.6z M182.6,225.6h-12v-6h12V225.6z M158.6,225.6h-12v-6h12V225.6 z M134.6,225.6h-12v-6h12V225.6z M110.6,225.6h-12v-6h12V225.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M866.8,177.8H9.5c-5.2,0-9.5-4.2-9.5-9.5s4.2-9.5,9.5-9.5h857.2c5.2,0,9.5,4.2,9.5,9.5S872,177.8,866.8,177.8z "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 428.1,
    y: 13.5,
    className: "st3",
    width: 20,
    height: 73.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "389.2,72.3 438.1,156.9 486.9,72.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricefloor);
export default __webpack_public_path__ + "static/media/Price floor.6a28e923d7a94fe2e1fc9de80662ec5f.svg";
export { ForwardRef as ReactComponent };